import tracker from '../../components/tracker/publish'

const eventTracker = (e, title, url, type) => {
  if (['parent category', 'category'].indexOf(type) === -1) {
    return
  }

  tracker.trackEvent('userevent', {
    type: 'Category Clicked',
    category_title: title,
    category_url: url,
    category_type: type,
    click_source: 'breadcrumb'
  })
}

const TitleWrapper = ({ url, title, type, children }) => {
  if (url) {
    return <a class='breadcrumb-item-link' href={url} onClick={(e) => eventTracker(e, title, url, type)}>{children}</a>
  } else {
    return <span class='current'>{children}</span>
  }
}

const types = ['homepage', 'parent category', 'category']
const qaClasses = [
  'qa-breadcrumb-community',
  'qa-breadcrumb-category',
  'qa-breadcrumb-forum',
  'qa-breadcrumb-topic'
]

const Breadcrumb = (props) => {
  return props.breadcrumbData.length === 0
    ? null
    : <ul className='breadcrumb'>
      { props.breadcrumbData.map((data, index) => <li className={`breadcrumb-item ${qaClasses[index]}`}>
        <TitleWrapper url={props.breadcrumbData.length > index + 1 ? data.url : null} title={data.title} type={types[index]}>
          <i className='icon icon--caret-left is-visible-S' />
          {data.title}
        </TitleWrapper>
        <i className='icon icon--caret-right' />
      </li>) }
    </ul>
}

export { TitleWrapper }
export default Breadcrumb
